import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const HeroSection = () => {
	const [isResponsibleAI, setIsResponsibleAI] = useState(true);

	useEffect(() => {
		const timer = setInterval(() => {
			setIsResponsibleAI((prev) => !prev);
		}, 6000);

		return () => clearInterval(timer);
	}, []);

	return (
		<section
			className="hero min-h-screen flex items-center bg-cover bg-center bg-fixed"
			style={{
				backgroundImage: 'url("https://cdn.prod.website-files.com/650dc6e8c3edc32394341ca0/667e7109654405b4e76c8a47_fdghj.png")',
			}}
		>
			<div className="container mx-auto px-4 flex flex-wrap items-center justify-between">
				{/* Left Content */}
				<div className="w-full md:w-1/2 text-center md:text-left flex flex-col items-center md:items-start">
					<h1 className="text-4xl md:text-6xl font-bold text-black leading-tight">
						Architecting{' '}
						<span
							className={`text-4xl md:text-6xl font-bold ${isResponsibleAI ? 'text-blue-600' : 'text-yellow-500'}`}
							style={{
								animation: `slowTextChange 10s ease-in-out infinite`,
							}}
						>
							{isResponsibleAI ? 'Responsible AI' : 'Privacy By Design'}
						</span>
					</h1>
					<h1 className="text-4xl md:text-6xl font-bold text-black mt-2">for enterprises</h1>

					<div className="mt-8 flex flex-col items-center md:items-start justify-start space-y-4 w-full">
						<img
							src="https://cdn.prod.website-files.com/650dc6e8c3edc32394341ca0/66f2a9b11eae3fcb34a1ce25_ISO.png"
							alt="ISO Logo"
							className="w-32 md:w-48"
							loading="lazy"
						/>

						<Link to="/get-started">
							<button className="bg-blue-500 text-white py-3 px-6 rounded-lg shadow-lg hover:bg-blue-600 transition mt-6 md:mt-8 mb-8 md:mb-12">Get Started →</button>
						</Link>
					</div>
				</div>

				<div className="w-full md:w-1/2 flex justify-center md:justify-end">
					<img
						src="https://cdn.prod.website-files.com/650dc6e8c3edc32394341ca0/667e9e1d1e7fc3dcaaf54f51_Group%201321316129.png"
						alt="AI Representation"
						className="rounded-lg shadow-lg max-w-full h-auto"
						loading="lazy"
					/>
				</div>

				<div className="mt-8 text-center text-3xl text-gray-800 w-full">Recognized Excellence in Privacy and AI Innovation</div>
			</div>

			{/* Animation */}
			<style>
				{`
          @keyframes slowTextChange {
            0% {
              opacity: 0;
              transform: translateY(-20px);
            }
            50% {
              opacity: 1;
              transform: translateY(0);
            }
            100% {
              opacity: 0;
              transform: translateY(20px);
            }
          }
        `}
			</style>
		</section>
	);
};

export default HeroSection;
